import '../index.css';

export default function TopHeader() {
    return null;
}
